import React from 'react';
import { Box, Checkbox, FormControlLabel, Typography } from '@material-ui/core';

const DcvCheckbox = ({ isDcvEnabled, setIsDcvEnabled, setForm, clusterSettings, orgClusterSettings, provider }) => {
    // Check org-scoped settings first (where GeneralSettingsTab saves), fall back to global
    const hprdEnabled = orgClusterSettings?.clusterSettings?.enableHighPerformanceRemoteDesktop
        || clusterSettings?.enableHighPerformanceRemoteDesktop;

    if (!hprdEnabled) return null;

    const caption = provider === 'aws'
        ? 'Install high-performance remote desktop during deployment (free on AWS EC2)'
        : 'Install high-performance remote desktop during deployment (requires license for non-AWS)';

    return (
        <Box mt={1}>
            <FormControlLabel
                control={
                    <Checkbox
                        checked={isDcvEnabled}
                        onChange={event => {
                            const newValue = event.target.checked;
                            setIsDcvEnabled(newValue);
                            setForm(prevForm => ({
                                ...prevForm,
                                info: {
                                    ...prevForm.info,
                                    dcvEnabled: newValue
                                }
                            }));
                        }}
                        name="dcvEnabled"
                        color="primary"
                    />
                }
                label="High Performance Remote Desktop"
            />
            <Typography variant="caption" color="textSecondary" display="block" style={{ marginLeft: 32 }}>
                {caption}
            </Typography>
        </Box>
    );
};

export default DcvCheckbox;
